import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SkillsState } from "./types";
import { SkillValue } from "../../../services/api/instances/skillsApi/types";

const initialState: SkillsState = {
  skillValue: null,
};

const skillsSlice = createSlice({
  name: "skills",
  initialState,
  reducers: {
    setSkillValue: (state, action: PayloadAction<SkillValue>) => {
      state.skillValue = action.payload;
    },
    clearSkillValue: (state) => {
      state.skillValue = null;
    },
  },
  extraReducers: (builder) => {},
});

export const skillsReducers = skillsSlice.reducer;
export const { setSkillValue, clearSkillValue } = skillsSlice.actions;
